import * as v from "valibot";
import { BaseRecordSchema, baseVals, defineValidation } from "../../common/validation.common";
import { VoucherCharsetEnum } from "../../data/enums";

export namespace HotspotVoucherValidation {
    export const Record = defineValidation(BaseRecordSchema);

    export const ResellerRecord = defineValidation(BaseRecordSchema);

    export const Create = defineValidation(
        v.object({
            group: baseVals.string(),
            productId: baseVals.string(),
            quantity: baseVals.intRange(1, 500, "Jumlah"),
            codeLength: baseVals.intRange(3, 10, "Panjang Karakter"),
            userLimit: v.optional(baseVals.intMin(1, "Batas Pengguna", { unit: "orang" })),
            lockUsersMAC: v.optional(v.boolean()),
            charset: v.optional(v.picklist(VoucherCharsetEnum.values)),
            dnsName: v.optional(baseVals.string()),
        }),
    );

    export const Update = defineValidation(
        v.object({
            isLimited: v.exactOptional(v.boolean()),
        }),
    );

    export const Render = defineValidation(
        v.object({
            templateId: baseVals.string(),
            paperWidth: v.number(),
            paperHeight: v.number(),
            vouchers: v.pipe(v.array(baseVals.string()), v.minLength(1), v.maxLength(500)),
        }),
    );

    export namespace API {
        export const Print = defineValidation(
            v.object({
                templateId: v.string(),
                vouchers: v.pipe(v.array(baseVals.string()), v.minLength(1), v.maxLength(500)),
            }),
        );

        export const Create = defineValidation(
            v.object({
                productId: baseVals.string(),
                quantity: baseVals.intRange(1, 500, "Jumlah"),
                codeLength: baseVals.intRange(6, 12, "Panjang Karakter"),
                notes: v.optional(baseVals.string("Catatan", 32)),
            }),
        );
    }
}
